/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2UnlockIcon from 'DesignSystem/Svgs/Tysiav2UnlockIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TaskBoardIcon/PrivateIndicator/Content"
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral300,'--brc-2-Z1Yf8zk': dtColorsWhite,'--blc-3-Z1Yf8zk': dtColorsWhite,'--btc-4-Z1Yf8zk': dtColorsWhite,'--bbc-5-Z1Yf8zk': dtColorsWhite}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2UnlockIcon
  viewPath={`${viewPath}/Tysiav2UnlockIcon`}
 width={20}
 height={20}
/>
</div>
{children}
</React.Fragment>)
}